import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Controller from '@ember/controller';
import type Session from '../services/session';

export interface PlaceMarker {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  emoji?: string;
  distance?: string; // Formatted distance from user location
}

export default class PlacesRoute extends Route {
  @service declare session: Session;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.session.isModerator) {
      this.router.transitionTo('index');
    }
  }

  model() {
    return {};
  }

  override setupController(controller: Controller, model: unknown): void {
    super.setupController(controller, model);
    (controller as unknown as { loadData: () => void }).loadData();
  }
}
